module.exports = __webpack_public_path__ + "img/conversation.9cac8539.svg";